import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { createStore, select, withProps } from '@ngneat/elf';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable, distinctUntilChanged } from 'rxjs';

import { ProfileCounts } from '@digital-platform/unified-wp-home/domain';
import { UwpWasteProfile } from '@digital-platform/unified-wp-waste-profile/domain';
import { WasteProfileRepositoryService } from '../waste-profile-repository-service/waste-profile-repository.service';

const profileListStore = createStore(
  {
    name: 'wpProfileList',
  },
  withProps<{ profiles: UwpWasteProfile[] }>({
    profiles: [],
  })
);

const wpRepositoryNavState = createStore(
  { name: 'wpRepositoryNav' },
  withProps<any>({
    counts: [],
    active: null,
  })
);

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class WasteProfileRepositoryFacadeService {
  public profileListState$ = wpRepositoryNavState.pipe(
    select((state) => state),
    distinctUntilChanged()
  );

  public navState$ = wpRepositoryNavState.pipe(
    select((state) => state),
    distinctUntilChanged()
  );

  private wasteProfileRepositoryService: WasteProfileRepositoryService = inject(
    WasteProfileRepositoryService
  );
  public router = inject(Router);

  public getWasteProfileList(): Observable<UwpWasteProfile[]> {
    return this.wasteProfileRepositoryService.getWasteProfileList();
  }

  public setWasteProfileList(profiles: UwpWasteProfile[]): void {
    profileListStore.update((state) => ({
      ...state,
      profiles: profiles,
    }));
  }

  setCounts(counts: ProfileCounts): void {
    wpRepositoryNavState.update((state) => ({
      ...state,
      counts: counts,
    }));
  }

  setQueryParam(activeStatus: string): void {
    this.router.navigate(['/profiling/waste-profile-repository'], {
      queryParams: { status: activeStatus },
    });
  }

  setActive(active: string): void {
    //   this.router.navigate(['/profiling/waste-profile-repository'], {
    //   queryParams: { status: active },
    // });
    wpRepositoryNavState.update((state) => ({
      ...state,
      active: active,
    }));
  }
}
